var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  ScreenClassify: () => ScreenClassify
});
var import_cardManager = __toModule(require("../card/cardManager"));
var import_screen = __toModule(require("./screen"));
class ScreenClassify extends import_screen.Screen {
  constructor(samaData, samaForm, screenName, navigationIndex) {
    super(samaData, samaForm, screenName, navigationIndex);
    this.samaData = samaData;
    this.samaForm = samaForm;
    this.screenName = screenName;
    this.navigationIndex = navigationIndex;
    this.validateScreenClassify();
    const cardGroupForm = this.samaForm.getCardForm(this.screenForm.cardsId[0]);
    this.cardManager = new import_cardManager.CardManager(samaData, samaForm, cardGroupForm, void 0);
  }
  validateScreenClassify() {
    if (!Array.isArray(this.screenForm.cardsId) || this.screenForm.cardsId.length !== 1) {
      throw new Error("ScreenClassify: screenForm.cards should be an array with only one element.");
    }
    if (!this.screenForm.yayoyakiCurrentId) {
      throw new Error("ScreenClassify: screenForm.yayoyakiCurrentId should be defined.");
    }
    if (!this.screenForm.yayoyakiParentId) {
      throw new Error("ScreenClassify: screenForm.yayoyakiParentId should be defined.");
    }
  }
  getCards() {
    return this.cardManager.list();
  }
  getNext() {
    const selectedCards = this.getSelected();
    for (const selectedCard of selectedCards) {
      const value = this.samaData.getValue(this.screenForm.yayoyakiParentId)[this.navigationIndex];
      this.samaData.setValue(this.screenForm.yayoyakiCurrentId, value, selectedCard.getIndex());
    }
    return super.getNext();
  }
  getSelected() {
    return this.cardManager.list().filter((card) => card.isSelected());
  }
  setSelected(card) {
    card.setSelected(true);
  }
  delete(card) {
    this.cardManager.delete(card);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ScreenClassify
});
